var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"experiment"},[_c('div',{staticClass:"bars"},_vm._l((_vm.bars_content),function(content,index){return _c('vue-file-toolbar-menu',{key:'bar-' + index,attrs:{"content":content}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }